export type AssessoriaRealitzadaLloc = 'caaj' | 'pij';

export enum AssessoriaRealitzadaLlocEnum {
  caaj = 'CAAJ',
  pij = 'PIJ Externalitzada',
}
